<template>
  <div class="community animated fadeIn">
    <div class="body">
      <div class="row">
          <div class="col-md-6 col-6">
             <SidebarView title="Community" single="true" />
          </div>
          <div class="col-md-6 col-6 text-right">
            <router-link to="/">
            <img src="../assets/images/icon.jpg" class="myicon" />
           </router-link>
        </div>
      </div>
      <br /><br />
      <div class="row">
          <div class="col-md-6 col-sm-12">
              <h4>NexaScale</h4>
              <p>
                  <strong>Role: Founder & Executive Director</strong>
              </p>
              <p>
                <a href="https://nexascale.org/" target="_blank">NexaScale</a> is a DC-incorporated nonprofit advancing economic opportunity by closing the gap between talented people and careers in tech. With 11,000+ members across six continents, we run bootcamps, mentorship programs, apprenticeships, and applied AI literacy initiatives across disciplines including Cloud Engineering, Data Science, Cybersecurity, Backend, Frontend, and Mobile Engineering. Our Future STEM Stars program brings AI education directly to secondary school girls in Nigeria, building the pipeline before opportunity gaps widen. Since 2023, NexaScale has produced hundreds of bootcamp graduates and made thousands of apprenticeship placements, and our community continues to grow as we expand our reach across Africa and beyond.
              </p>
          </div>
          <div class="col-md-6 col-sm-12">
              <h4>Platform Engineering</h4>
              <p>
                  <strong>Role: Ambassador</strong>
              </p>
              <p><a href="https://platformengineering.org/ambassador-program" target="_blank">PlatformEngineering.org</a> is the global home for platform engineering practitioners, connecting engineers, leaders, and organizations around Internal Developer Platforms, developer experience, and the discipline of treating platforms as products. As an Ambassador, I contribute to advancing platform engineering practice through speaking, writing, and community engagement at events including PlatformCon. I help companies and engineers navigate the shift toward AI-ready platforms and understand how platform thinking unlocks developer productivity at scale. The program brings together a select group of practitioners to share knowledge, challenge assumptions, and accelerate adoption of platform engineering across the industry.</p>
          </div>
      </div>
      <hr />
      <div class="row">
            <div class="col-md-6 col-sm-12">
              <h4>Agentic AI Foundation (AAIF)</h4>
              <p>
                  <strong>Role: Ambassador, Inaugural Cohort</strong>
              </p>
              <p>
                The <a href="https://aaif.io/ambassadors/" target="_blank">Agentic AI Foundation</a> is a directed fund under the Linux Foundation, co-founded by Anthropic, OpenAI, and Block, with support from Google, Microsoft, AWS, Cloudflare, and Bloomberg. It provides neutral, community-driven stewardship for the open standards powering the agentic AI era, including MCP, AGENTS.md, and Goose. As a member of the inaugural Ambassador cohort, I create technical content, tutorials, and educational resources that help developers understand, try, and build with AAIF projects. My focus sits at the intersection of agentic AI and platform engineering, exploring how production teams can govern, operate, and scale agent-based systems with the same rigor they bring to the rest of their infrastructure.</p>
          </div>
          <div class="col-md-6 col-sm-12">
              <h4>Women Tech Network</h4>
              <p>
                  <strong>Role: Mentor</strong>
              </p>
              <p>
                <a href="https://www.womentech.net/" target="_blank">Women Tech Network</a> is a global community dedicated to connecting, supporting, and elevating women in technology at every stage of their careers. The network brings together professionals across engineering, product, leadership, and research to build meaningful relationships, share experience, and advocate for greater representation in the industry. As a member, I engage with a global community of women building and leading in tech, contribute to conversations on inclusion and advancement, and participate in events and initiatives that create real access and opportunity. The community reflects a shared belief that diverse perspectives build better technology and stronger teams.
              </p>
          </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-6 col-sm-12">
                <h4>DevNetwork</h4>
                <p>
                    <strong>Role: Management Advisory Board Member</strong>
                </p>
                <p>
                    <a href="https://www.devnetwork.com/advisory-board/adora-nwodo/" target="_blank">DevNetwork</a> is the destination for the global developer, engineering, and IT community, producing the world's largest developer conference series including DeveloperWeek, which reaches 50,000+ participants annually from more than 70 countries. As a member of the Management Advisory Board, a board focused on engineering leadership and technology executive perspectives, I help shape the content and speaker direction of DevNetwork events to reflect what engineering leaders actually need to learn and discuss. Board members also judge industry awards and hackathons and participate in the annual VIP Industry Summit. It is a role that keeps me connected to where the global developer and engineering leadership conversation is headed.
                </p>
            </div>
            <div class="col-md-6 col-sm-12">
                <h4>Microsoft</h4>
                <p>
                    <strong>Role: Azure Most Valuable Professional (MVP)</strong>
                </p>
                <p>
                    <a href="https://mvp.microsoft.com/en-us/mvp" target="_blank">Microsoft's MVP Award</a> is a global recognition program honoring technologists who demonstrate exceptional community leadership and technical expertise across Microsoft technologies. MVPs are practitioners who actively share knowledge, educate peers, and contribute to the broader tech community through speaking, writing, open source, and mentorship. As an Azure MVP, I am recognized for my contributions to the Azure ecosystem spanning cloud infrastructure, developer tooling, and AI. The award reflects years of community investment through conference talks, published books, and programs that bring Azure knowledge to engineers at every level around the world.
                </p>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-6 col-sm-12">
                <h4>NET Foundation</h4>
                <p>
                    <strong>Role: Member</strong>
                </p>
                <p>
                    The <a href="https://dotnetfoundation.org/" target="_blank">.NET Foundation</a> is an independent, nonprofit organization established to support the open source ecosystem around the .NET platform. It champions community-driven development, fosters collaboration between contributors and Microsoft, and ensures that .NET remains open, accessible, and sustainable for developers worldwide. As a member, I contribute to a community of engineers advancing one of the most widely used development platforms in enterprise and cloud engineering. My involvement reflects a long-standing connection to the .NET ecosystem through authorship, speaking, and building production systems on the platform across my engineering career.
                </p>
            </div>
          </div>
      </div>
    </div>
    <FooterView />
</template>

<script>
import SidebarView from '@/components/SidebarView.vue' 
import FooterView from '@/components/FooterView.vue' 

export default {
    components: { 
        SidebarView,
        FooterView
    }
}
</script>

<style scoped>
.community .col-md-6{
    margin-bottom: 40px;
}
.community .community-pic{
    width: 100%;
    border-radius: 50px;
    -webkit-box-shadow: 0px 6px 26px -15px rgba(0, 0, 0, 0.65);
-moz-box-shadow: 0px 6px 26px -15px rgba(0,0,0,0.65);
box-shadow: 0px 6px 26px -15px rgba(0,0,0,0.65);
}
.community p{
    font-size: 14px;
}
.community p a{
    color: #c12688;
}
.community hr{
    border-color: #c126884b;
    margin-bottom: 50px;
}
</style>
